import { useEffect, useState } from 'react'
import useAbortController from './useAbortController'
import useBoolean from './useBoolean'
import { isNil } from 'lodash'
import AnalysisAction from 'quality/actions/AnalysisAction'
import DtoAnalysisLight from 'quality/dto/analyse/DtoAnalysisLight'
import { useDispatch } from 'react-redux'

const useFetchAnalysis = (filters) => {
    const {
        controllerRef,
        initController,
    } = useAbortController()

    const {
        value: isLoaded,
        setFalse: setNotLoaded,
        setTrue: setLoaded,
    } = useBoolean(false)
    const [progress, setProgress] = useState(0)

    const [analysis, setAnalysis] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        if (filters.stations.length === 0 || isNil(filters.startDate) || isNil(filters.endDate)) return

        setNotLoaded()
        setProgress(0)
        initController()
        setAnalysis([])


        dispatch(AnalysisAction.getAllAnalysisSeq(
            filters,
            controllerRef.current.signal,
            p => setProgress(p),
            list => {
                setAnalysis(p => [...p, ...list.map(a => new DtoAnalysisLight(a))])
                if (!controllerRef.current.signal.aborted) {
                    setLoaded()
                }
            },
        ))


        // eslint-disable-next-line consistent-return
        return () => {
            controllerRef.current.abort()
        }
    }, [filters])

    return {
        analysis,
        isLoaded,
        progress,
    }
}

export default useFetchAnalysis